function createAPIRoute(handler) {
  return handler;
}
export {
  createAPIRoute
};
//# sourceMappingURL=createAPIRoute.js.map
